import { render, staticRenderFns } from "./Approver.vue?vue&type=template&id=1596bab4&scoped=true"
import script from "./Approver.vue?vue&type=script&lang=js"
export * from "./Approver.vue?vue&type=script&lang=js"
import style0 from "./Approver.vue?vue&type=style&index=0&id=1596bab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596bab4",
  null
  
)

export default component.exports